import { useEffect } from 'react'
import { emitAppScroll } from './scrollEvents'

/** Emite sosvor-scroll no scroll nativo (substitui Lenis removido do layout). */
export function useAppScrollEmitter(enabled = true) {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return undefined

    const notify = () => emitAppScroll()

    window.addEventListener('scroll', notify, { passive: true, capture: true })
    window.addEventListener('wheel', notify, { passive: true, capture: true })
    window.addEventListener('touchmove', notify, { passive: true, capture: true })

    return () => {
      window.removeEventListener('scroll', notify, { capture: true })
      window.removeEventListener('wheel', notify, { capture: true })
      window.removeEventListener('touchmove', notify, { capture: true })
    }
  }, [enabled])
}
